import error from './errors';
import fields from './fields';

export default {
  error,
  fields,
  app: {
    title: 'Legalizaciones'
  },
  btn: {
    next: 'Next',
    prev: 'Previous',
    cancel: 'Cancel',
    back: 'Go back',
    search: 'Search',
    solicitar: 'Apply',
    finalizar: 'Go home',
    verificar: 'Check',
    cambiar: 'Change',
    register: 'Registering...',
    solicitando: 'Applying for...'
  },
  months: {
    enero: 'January',
    febrero: 'February',
    marzo: 'March',
    abril: 'April',
    mayo: 'May',
    junio: 'June',
    julio: 'July',
    agosto: 'August',
    septiembre: 'September',
    octubre: 'October',
    noviembre: 'November',
    diciembre: 'December'
  },
  menu: {
    inicio: 'Home',
    tramite: 'Paperwork',
    solicitud: 'Apply for',
    seguimiento: 'Tracking',
    verificar: 'Check',
    contacto: 'Contact'
  },
  steps: {
    info_sol: 'APPLICANT INFORMATION',
    info_doc: 'DOCUMENT(S)',
    info_doc_adjuntar: 'ATTACH FILE(S)',
    info_pago: 'PAYMENT INFORMATION',
    info_finalizado: 'FINISHED'
  },
  inicio: {
    title: 'PLATAFORMA DE LEGALIZACIONES y CERTIFICACIONES',
    detalle: 'The new platform of legalizations and certifications is to provide you with you better conditions.',
    btnSolicitar: 'Apply',
    btnSeguimiento: 'State of my process',
    btnVerificar: 'Verify'
  },
  tramite: {
    title: 'List of legalization/certification process'
  },
  solicitud: {
    title: 'Legalization/Certification application form',
    datos_titular: `<strong>Document holder.-</strong>  It is the information of the person whom the document for legalize or certify belongs.`
  },
  seguimiento: {
    title: 'Follow up of your process'
  },
  verificar: {
    title: 'Verify document'
  },
  BUSCAR_TRAMITE: 'Search process',
  PRECIO: 'Price',
  VER_DETALLES: 'More details',
  SOLICITAR_LEGALIZACION: 'Apply for legalization',
  SOLICITAR_CERTIFICACION: 'Apply for certification',
  ESCRIBIR_TRAMITE: 'Enter the procedure to search'
};



// WEBPACK FOOTER //
// ./src/lang/en/messages.js